module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/preface#toc1a",
      "id": "toc1"
    }
  }, [_vm._v("Preface: Maize for the Metate")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#toc2a",
      "id": "toc2"
    }
  }, [_vm._v("Phantoms in the Mirror")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#toc3a",
      "id": "toc3"
    }
  }, [_vm._v("The “Good Old Mission Days” Never Existed")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#toc4a",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Josefa of Downieville: The Obscure Life and Notable Death of a Chicana in Gold Rush California")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#toc5a",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triptych: Memories of the San Fernando Valley")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#toc6a",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gathering Thunder")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#toc7a",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tropi(lo)calidad:")]), _vm._v(" Macondo in La Mission")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#toc8a",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petroglyph of Memory")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#toc9a",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Marin Headlands: A Meditation on Place")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#toc10a",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Homecoming of an Azteca-Mexica Clan")])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/notes#toc11a",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography#toc12a",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/ack#toc13a",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0